import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VoleiProtocol } from '../../../../models/voleiprotocol';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { VoleiProtocolService } from '../../../../services/volei-protocol.service';
import { DialogService } from '../../../../services/dialog.service';
import { ToastService } from '../../../../services/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-volei-protocol',
  templateUrl: './adm-volei-protocol.component.html',
  styleUrls: ['./adm-volei-protocol.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmVoleiProtocolComponent implements OnInit {

  submitted = false;
  error = '';
  saving: boolean = false;
  formVoleiProtocol: UntypedFormGroup;

  active: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  voleiProtocol: VoleiProtocol;

  displayedColumns: string[] = [
    'id',
    'name',
    'timeBefore',
    'refereeType',
    'actions',
  ];
  dataSource: any = [];

  settings = {
    columns: {
      id: {
        title: 'ID',
      },
      name: {
        title: 'Evento',
      },
      timeBefore: {
        title: 'Minutos Antes',
      }
    },
  };


  constructor(
    private authorizeService: AuthService,
    private voleiProtocolService: VoleiProtocolService,
    private modalService: NgbModal,
    private dialogService: DialogService,
    private toastService: ToastService,
    private router: Router
  ) { }

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user != null) {
      this.createForm(new VoleiProtocol());
      this.loadGrid();
    } else {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/adm/volei-protocol' }
      });
    }
  }

  get f() {
    return this.formVoleiProtocol.controls;
  }


  createForm(voleiProtocolForm: VoleiProtocol) {
    this.formVoleiProtocol = new UntypedFormGroup({
      id: new UntypedFormControl(voleiProtocolForm.id),
      name: new UntypedFormControl(voleiProtocolForm.name, Validators.required),
      timeBefore: new UntypedFormControl(voleiProtocolForm.timeBefore, Validators.required),
      observations: new UntypedFormControl(voleiProtocolForm.observations, Validators.required),
      refereeType: new UntypedFormControl(voleiProtocolForm.refereeType ?? 1, Validators.required),
    });
  }



  loadGrid() {
    this.voleiProtocolService.get().subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  open(content: any) {
    this.voleiProtocol = new VoleiProtocol();
    this.createForm(this.voleiProtocol);
    this.modalService.open(content, { size: 'lg' });
  }

  create(content: any): void {
    this.createForm(new VoleiProtocol());
    this.modalService.open(content);
  }

  edit(content: any, id: number) {
    this.submitted = false;
    this.voleiProtocolService.getById(id).subscribe((res) => {
      this.voleiProtocol = res;
      this.formVoleiProtocol.setValue({
        id: this.voleiProtocol.id,
        name: this.voleiProtocol.name,
        timeBefore: this.voleiProtocol.timeBefore,
        observations: this.voleiProtocol.observations,
        refereeType: this.voleiProtocol.refereeType ?? 1,
      });
      this.modalService.open(content);
    });
  }

  submitForm() {
    this.submitted = true;

    if (this.formVoleiProtocol.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.voleiProtocol = this.formVoleiProtocol.value;
    if (this.voleiProtocol.id > 0) {
      this.voleiProtocolService.put(this.voleiProtocol.id, this.formVoleiProtocol.value).subscribe({
        next: (res) => {
          this.voleiProtocol = res;
          this.loadGrid();
          this.toastService.show('Sucesso', { type: 'success' });
          this.modalService.dismissAll();
        },
        error: () => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        },
      });
    } else {
      this.voleiProtocol.id = 0;
      this.voleiProtocolService.post(this.voleiProtocol).subscribe({
        next: (res) => {
          this.toastService.show('Sucesso', { type: 'success' });
          this.loadGrid();
          this.modalService.dismissAll();
        },
        error: () => {
          this.toastService.show('Erro ao criar!', { type: 'danger' });
        },
      });
    }
  }

  async deleteItem(id: number) {
    this.active = true;

    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.voleiProtocolService.delete(id).subscribe({
        next: (res: any) => {
          this.toastService.show('Sucesso', { type: 'success' });
        },
        error: (err) => {
          this.toastService.show('Erro', { type: 'danger' });
        },
      });
    }
  }

}
